import { render, staticRenderFns } from "./coachWithdrawDeposit.vue?vue&type=template&id=23070258&scoped=true"
import script from "./coachWithdrawDeposit.vue?vue&type=script&lang=ts"
export * from "./coachWithdrawDeposit.vue?vue&type=script&lang=ts"
import style0 from "./coachWithdrawDeposit.vue?vue&type=style&index=0&id=23070258&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23070258",
  null
  
)

export default component.exports